import React, { FC } from 'react'

import { UseSiteSettings } from '../../../../../../hooks/useSiteSettings'
import { defaultCommissionsOptOutLabel } from '../../../../../../lib/practitioner-settings/utils'
import { StyledLink, StyledSmallParagraph } from '../styled'

export const CommissionsOptOutMessage: FC<{
  commissionsOptOutForm: UseSiteSettings['commissionsOptOutForm']
}> = ({ commissionsOptOutForm }) => {
  return commissionsOptOutForm?.link ? (
    <StyledSmallParagraph>
      If for any reason you do not wish to earn commissions, click{' '}
      <StyledLink to={commissionsOptOutForm.link} target="_blank">
        here
      </StyledLink>{' '}
      to submit the {commissionsOptOutForm.label || defaultCommissionsOptOutLabel} form.
    </StyledSmallParagraph>
  ) : null
}
